import { render } from "./Login.vue?vue&type=template&id=5c389940&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=5c389940&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-5c389940"

export default script